// 工作台
const Dashboard = () => import('@/views/dashboard/index.vue')

export default {
  Dashboard
}
